import { createFileRoute, Link } from "@tanstack/react-router";
import { EditablePageShell, useSitePage } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import miniGolf from "@/assets/mini-golf.jpg";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/mini-golf")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("mini-golf")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Mini Golf with Glow Long Golf Balls" },
      { name: "description", content: loaderData?.meta_description || "Glow-in-the-dark mini golf for backyards, basements, and after-dark events. Bright, even glow on every putt." },
      { property: "og:title", content: loaderData?.title || "Mini Golf with Glow Long Golf Balls" },
      { property: "og:description", content: loaderData?.meta_description || "Glow-in-the-dark mini golf for backyards, basements, and after-dark events." },
      { property: "og:url", content: "https://glowlonggolf.com/mini-golf" },
      { property: "og:image", content: SHARE_IMAGES.nightMiniGolf },
      { name: "twitter:image", content: SHARE_IMAGES.nightMiniGolf },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/mini-golf" }],
  }),

  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: MiniGolfPage,
});

function MiniGolfPage() {
  const page = useSitePage("mini-golf");
  const img = page?.hero_image_url || miniGolf;
  return (
    <EditablePageShell
      slug="mini-golf"
      defaults={{
        eyebrow: "Mini Golf",
        title: "Putt-putt that glows after dark",
        lead: "Backyards, basements, glow-course nights, and pop-up events — Glow Long turns mini golf into a light show.",
      }}
    >
      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-2 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-border bg-card">
          <img src={img} alt="Glow mini golf at night" className="h-full w-full object-cover" loading="lazy" />
        </div>
        <div className="space-y-4 text-muted-foreground">
          <h2 className="font-display text-2xl font-semibold text-foreground">Built for after-dark putting</h2>
          <p>Charge under any light, drop a putter in someone's hand, and the course becomes a glow-in-the-dark experience — no batteries, no extra gear.</p>
          <p>Great for backyard courses, indoor putting mats, kids' birthdays, and mini-golf venues running after-dark events.</p>
          <Link to="/shop" className="inline-flex rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90">
            Shop glow balls
          </Link>
        </div>
      </section>
    </EditablePageShell>
  );
}
